export default "__VITE_ASSET__BSLQY9VP__"